import React from "react";
import { Col, Row, Typography, Card, Divider, Space } from "antd";
import { MailOutlined, PhoneOutlined, ClockCircleOutlined } from "@ant-design/icons";

const { Title, Paragraph, Text } = Typography;

const Support = () => {
  return (
    <Row type="flex">
      <Col span={20} offset={1}>
        <Title level={2}>Support & Contact Information</Title>
        <Paragraph style={{ fontSize: '16px', marginBottom: '24px' }}>
          If at any time during this process you have questions or concerns, please don't hesitate 
          to contact us. Our support team is here to help you successfully complete your Pre-Qualification 
          Questionnaire (PQQ).
        </Paragraph>

        <Divider />

        <Title level={4}>Contact Methods</Title>
        <Space direction="vertical" size="large" style={{ width: '100%', marginBottom: '24px' }}>
          <Card>
            <Space size="large">
              <MailOutlined style={{ fontSize: '32px', color: '#1890ff' }} />
              <div>
                <Title level={4} style={{ margin: 0 }}>Email Support</Title>
                <Paragraph style={{ marginBottom: '4px' }}>
                  <Text strong>Email:</Text> <a href="mailto:info@i4strategies.com">info@i4strategies.com</a>
                </Paragraph>
                <Paragraph style={{ marginBottom: 0, color: '#666' }}>
                  Send us an email with your questions or concerns. We typically respond within 1-2 business days.
                </Paragraph>
              </div>
            </Space>
          </Card>

          <Card>
            <Space size="large">
              <PhoneOutlined style={{ fontSize: '32px', color: '#52c41a' }} />
              <div>
                <Title level={4} style={{ margin: 0 }}>Phone Support</Title>
                <Paragraph style={{ marginBottom: '4px' }}>
                  <Text strong>Phone:</Text> <a href="tel:212-909-9580">212-909-9580</a>
                </Paragraph>
                <Paragraph style={{ marginBottom: 0, color: '#666' }}>
                  Call us during business hours for immediate assistance with your PQQ process.
                </Paragraph>
              </div>
            </Space>
          </Card>
        </Space>

        <Divider />

        <Title level={4}>What to Include When Contacting Support</Title>
        <Paragraph>
          To help us assist you more effectively, please include the following information when contacting support:
        </Paragraph>
        <ul style={{ paddingLeft: '20px' }}>
          <li>Your company name and vendor ID (if available)</li>
          <li>A clear description of your question or issue</li>
          <li>Any error messages you're seeing (screenshot if possible)</li>
          <li>What section of the process you're working on</li>
          <li>Steps you've already taken to resolve the issue</li>
        </ul>

        <Divider />

        <Title level={4}>Common Support Topics</Title>
        <Paragraph>
          Our support team frequently assists with:
        </Paragraph>
        <ul style={{ paddingLeft: '20px' }}>
          <li>Account setup and user management</li>
          <li>Profile completion questions</li>
          <li>Document upload issues</li>
          <li>Payment processing problems</li>
          <li>PQQ submission and certification</li>
          <li>Technical issues and error messages</li>
          <li>Permission and access questions</li>
          <li>Status inquiries for submitted PQQs</li>
        </ul>

        <Divider />

        <Title level={4}>Self-Service Resources</Title>
        <Paragraph>
          Before contacting support, you may find answers to your questions in our help documentation:
        </Paragraph>
        <ul style={{ paddingLeft: '20px' }}>
          <li>
            <Text strong>Overview:</Text> General information about the PQQ process
          </li>
          <li>
            <Text strong>Guides:</Text> Step-by-step instructions for each part of the process
          </li>
          <li>
            <Text strong>Required Documentation:</Text> Complete list of needed documents
          </li>
          <li>
            <Text strong>FAQ Sections:</Text> Common questions and answers for:
            <ul>
              <li>i4 Vendor Profile</li>
              <li>Payment</li>
              <li>PQQ Submission</li>
              <li>Account Management</li>
            </ul>
          </li>
        </ul>

        <Divider />

        <Title level={4}>Response Times</Title>
        <Card style={{ backgroundColor: '#f0f2f5' }}>
          <Space size="middle">
            <ClockCircleOutlined style={{ fontSize: '24px', color: '#1890ff' }} />
            <div>
              <Paragraph style={{ marginBottom: '4px' }}>
                <Text strong>Email:</Text> We aim to respond to email inquiries within 1-2 business days.
              </Paragraph>
              <Paragraph style={{ marginBottom: 0 }}>
                <Text strong>Phone:</Text> Available during regular business hours. Leave a message if 
                we're unable to answer immediately, and we'll return your call.
              </Paragraph>
            </div>
          </Space>
        </Card>

        <Divider />

        <Title level={4}>Technical Issues</Title>
        <Paragraph>
          If you're experiencing technical issues with the portal:
        </Paragraph>
        <ol style={{ paddingLeft: '20px' }}>
          <li>Try refreshing the page or clearing your browser cache</li>
          <li>Ensure you're using a supported, up-to-date browser</li>
          <li>Check your internet connection</li>
          <li>Try using a different browser or device</li>
          <li>Take a screenshot of any error messages</li>
          <li>Contact support with details about the issue</li>
        </ol>

      </Col>
    </Row>
  );
};

export default Support;
